import {
  AssetType,
  Button,
  CloseIcon,
  ConsentOrdersPathName,
  FormNavigation,
  RealEstateBaseProps,
  RealEstateProps,
  RealEstate_InitialState,
  Stepper,
  toast
} from "@fla/components";
import classNames from "classnames";
import { useConsentOrders } from "hooks/ConsentOrders";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { formSteps } from "./steps";

const initialState = {
  street: "",
  suburb: "",
  state: "",
  postcode: "",
  value: "",
  owner: "",

  if_mortgage_on_property: "",
  mortgage: [],

  property_status: "",
  sale_proceeds: "",
  sale_proceeds_owner: "",
  split_by_percentage: { user: "", spouse: "" },
  split_balance: { user: "", spouse: "" },
  property_keeper: "",
  payer: "",
  paying_settlement: "",
  payment_method: "",
  payment_by_fixed: "",
  payment_by_percentage: { user: "", spouse: "" },
  payment_details: "",
  other_person_amount: "",

  payments: []
};

export default function AddRealEstate() {
  const location = useLocation() as { state: { child: RealEstate_InitialState; parent: RealEstateBaseProps } };
  const editData = location.state?.child;

  const navigation = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [formState, setFormState] = useState(
    useMemo(() => {
      if (editData?.id) {
        const obj = Object.assign({}, editData);
        delete obj.id;
        delete obj.uid;
        delete obj.createdAt;
        delete obj.type;

        return obj;
      } else {
        return initialState;
      }
    }, [editData])
  );

  const CurrentTab = formSteps[currentStep as keyof typeof formSteps];

  const isLastStep = () => currentStep === Object.keys(formSteps).length;
  const isFirstStep = () => currentStep === 1;

  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const { addAsset, deleteAsset, isDeleting, isSubmitting } = useConsentOrders();

  const handleBackClick = () => {
    if (!isFirst) {
      setCurrentStep(prev => prev - 1);
    } else {
      navigation(ConsentOrdersPathName.RealEstate, {
        state: location.state?.parent,
        replace: true
      });
    }
  };

  const onSubmit = async (formData: RealEstateProps) => {
    setFormState(prevState => ({ ...prevState, ...formData }));

    if (!isLast) setCurrentStep(prev => prev + 1);
    else {
      try {
        addAsset({
          ...formData,
          type: AssetType.REAL_ESTATE,
          id: editData?.id
        });
      } catch (error: any) {
        toast({
          type: "error",
          message: error?.message || "something went wrong, please try again!"
        });
      }
    }
  };

  const onDelete = () => {
    if (editData?.id) deleteAsset(editData.id);
  };

  return (
    <section className="w-full h-[calc(100vh_-_64px)] md:h-screen overflow-y-auto">
      <section className="w-full md:w-10/12 lg:max-w-2xl mx-auto my-10">
        <Stepper steps={[1, 2, 3]} currentStep={currentStep} classes="w-full max-w-xs !mx-auto !my-10" />
        <div
          className={classNames("md:bg-white rounded-xl w-full h-fit py-5 md:shadow-md mx-auto", {
            "px-10": currentStep < 3
          })}
        >
          <CurrentTab formId="add-real-estate" store={formState} onSubmit={onSubmit} />

          {editData?.id ? (
            <Button
              className="mx-auto mt-10 mb-32 px-7 py-2 space-x-2 flex items-center group uppercase"
              isSubmitting={isDeleting}
              onClick={onDelete}
              // btnType="danger"
              // appearance="outline"
            >
              <CloseIcon classes="fill-current group-hover:text-white text-red-500" />
              <p>Delete Property</p>
            </Button>
          ) : null}

          <FormNavigation
            isFirst={false}
            isLast={isLast}
            form="add-real-estate"
            handleBackClick={handleBackClick}
            nextButtonText="Continue"
            isSubmitting={isSubmitting}
            classes={classNames("mt-12", {
              "px-10": currentStep === 3
            })}
          />
        </div>
      </section>
    </section>
  );
}
